import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const importersForFields = api((fields) =>
    query(
        gql`
            query GetImportersForFields($fields: [String]!) {
                importersForFields(fields: $fields) {
                    name
                    mapping
                    created
                }
            }
        `,
        { fields },
        { returns: "importersForFields" }
    )
)
